import styled from '@emotion/styled';
import ImageCard from './ImageCard';
import anime from 'animejs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'store/config';
import { CUSTOM_BREAK_POINT } from '../Block.styled';

type Props = {};

const GroupUpImages = (props: Props) => {
  const isMobile = useAppSelector((state) => state.global.isMobile);
  const [isDisplay, setIsDisplay] = useState(true);

  const STD_Y = 50;
  const STD_X = 0;
  const CARD_SIZE = 31;
  const ioRef = useRef<HTMLDivElement>(null);
  const animateImage = () => {
    anime({
      targets: '#bag',
      translateX: '+= 250',
      translateY: '-= 0',
      opacity: 0,
      easing: 'easeInOutSine',
      duration: 500,
    });

    anime({
      targets: '#head',
      translateX: '+= 130',
      translateY: '+= 80',
      opacity: 0,
      easing: 'easeInOutSine',
      duration: 500,
    });

    anime({
      targets: '#acc',
      translateX: '-= 90',
      translateY: '+= 150',
      opacity: 0,
      easing: 'easeInOutSine',
      duration: 500,
    });

    anime({
      targets: '#clothes',
      translateX: '-= 150',
      translateY: '+= 50',
      opacity: 0,
      easing: 'easeInOutSine',
      duration: 500,
    });

    anime({
      targets: '#shoes',
      translateX: '-= 250',
      translateY: '-= 40',
      opacity: 0,
      easing: 'easeInOutSine',
      duration: 500,
    });

    anime({
      targets: '#before',
      opacity: 0,
      easing: 'easeInOutSine',
      duration: 500,
    });

    anime({
      targets: '#after',
      opacity: 1,
      easing: 'easeInOutSine',
      duration: 1000,
    });

    anime({
      targets: '#frame',
      opacity: 1,
      easing: 'easeInOutSine',
      duration: 1000,
    }).finished.then(() => {
      setTimeout(() => {
        setIsDisplay(false);
      }, 2000);

      anime({
        targets: '#after',
        scale: 1.3,
        easing: 'easeInOutSine',
        duration: 1000,
      });
      anime({
        targets: '#frame',
        scale: 1.3,
        easing: 'easeInOutSine',
        duration: 1000,
      });
      // finished.then은 위 애니메이션이 끝나고, 새로운 애니메이션을 시작함. (별도의 loop)
      // timeline은 위 애니메이션이 끝나고, 이어서 애니메이션을 시작함. (한 loop)
      // anime({
      //   targets: '#chewka',
      //   easing: 'easeInOutSine',
      //   duration: 1000,
      //   translateY: '-= 10',
      //   direction: 'alternate', // (0% -> 100% -> 0%)
      //   loop: true,
      // });
    });
  };

  const animateImageWithIO = useCallback(
    ([entry]: any, observer: { unobserve: (arg0: any) => void }) => {
      if (entry.intersectionRatio > 0) {
        animateImage();
        observer.unobserve(entry.target);
      }
    },
    [],
  );

  // intersection observer
  useEffect(() => {
    const observer = new IntersectionObserver(animateImageWithIO, {
      threshold: 0.7,
    });

    observer.observe(ioRef.current);

    return () => {
      observer && observer.disconnect();
    };
  }, [animateImageWithIO]);
  return (
    <ImagesWrapper ref={ioRef}>
      {isMobile ? (
        ''
      ) : (
        <>
          <ImageCard
            id='bag'
            className='parts'
            image='/images/parts_bag.png'
            size={CARD_SIZE - 2}
            top={STD_Y + 20}
            left={STD_X + -230}
            rotate={-20}
            isDisplay={isDisplay}
          />
          <ImageCard
            id='head'
            className='parts'
            image='/images/parts_hair.png'
            size={CARD_SIZE - 2}
            top={STD_Y + -100}
            left={STD_X + -140}
            rotate={-10}
            isDisplay={isDisplay}
          />
          <ImageCard
            id='acc'
            className='parts'
            image='/images/parts_acc.png'
            size={CARD_SIZE - 2}
            top={STD_Y + -140}
            left={STD_X + 70}
            rotate={5}
            isDisplay={isDisplay}
          />
          <ImageCard
            id='shoes'
            className='parts'
            image='/images/parts_shose.png'
            size={CARD_SIZE - 2}
            top={STD_Y + 80}
            left={STD_X + 230}
            rotate={10}
            isDisplay={isDisplay}
          />
          <ImageCard
            id='clothes'
            className='parts'
            image='/images/parts_cloth.png'
            size={CARD_SIZE - 2}
            top={STD_Y + -20}
            left={STD_X + 130}
            rotate={30}
            isDisplay={isDisplay}
          />
        </>
      )}

      <ImageCard
        id='after'
        className='chewka'
        image='/images/gummyCard.png'
        size={CARD_SIZE}
        top={STD_Y} // 50
        left={STD_X} // 110
        rotate={0}
      />
      <ImageCard
        id='frame'
        className='chewka'
        image='/images/frame.gif'
        size={CARD_SIZE}
        top={STD_Y}
        left={STD_X}
        rotate={0}
      />

      <ImageCard
        id='before'
        className='chewka'
        image='/images/parts_body.png'
        size={CARD_SIZE}
        top={STD_Y}
        left={STD_X}
        rotate={0}
      />
    </ImagesWrapper>
  );
};

const ImagesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
  width: 500px;
  height: 500px;
`;

export default GroupUpImages;
